<template>

	<div :class="{'page-message': true, invert: invert}">

		<h2 class="heading" v-html="title" v-if="title!==''" />

		<p><slot /></p>

	</div>

</template>

<script>
export default {
	name: 'PageMessage',
	props: {
		title: {
			type: String,
			default: ''
		},
		invert: {
			type: Boolean,
			default: false
		}
	},
	computed: {},
	mounted() {
	},
	methods: {
	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
.page-message {
	background-color: #fff;
	padding: 20px;
	.heading {
		font-size: 20px;
    	margin-bottom: 5px;
	}
	p {
		padding:0;
		margin: 0 0 20px;
		&:last-child {
			margin: 0;
		}
	}

	&.invert {
		background-color: @darkContrast;
		.heading, p, a, span {
			color: #fff;
		}
	}
}
</style>